import {isPlatformBrowser} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {LAUNCH_CALLER, LaunchDialogService} from '@spartacus/storefront';
import {CLOSE_EVENT} from '../constants';
import {ISupportFormService} from '../interfaces';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root',
})
export class SupportFormService implements ISupportFormService {
  private messageHandler: (event: any) => void = (event) => {
    if (event.data?.eventId === CLOSE_EVENT) {
      this.close();
      event.stopPropagation();
    }
  };

  constructor(
    @Inject(PLATFORM_ID) protected platformId: object,
    protected launchDialogService: LaunchDialogService,
    protected configService: ConfigService,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('message', this.messageHandler, false);
    }
  }

  open(errorMessage?: string, errorCode?: string, targetUrl?: string): void {
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.SUPPORT_FORM, undefined, {
      errorMessage,
      errorCode,
      targetUrl,
    });
  }

  close(): void {
    this.launchDialogService.closeDialog('close');
  }

  openSupportFormFromLink(queryParameters: any): void {
    this.open(undefined, undefined, this.configService.getString('supportForm.baseUrl') + queryParameters);
  }

  get isEnabled(): boolean {
    return this.configService.getBoolean('features.enabledNewSupportForm');
  }
}
